import {RolesI18n} from '@/locales/base.message.locales';

export const roles: RolesI18n = {
  admin: 'Admin',
  judge: 'Judge',
  advisor: 'Advisor',
  master_admin: 'Admin',
  partner: 'Partner',
  contestant: 'Contestant'
};
